import React from 'react'
import { Link } from 'react-router-dom'

const SearchFilter = ({ searchValue, setSearchValue ,setCurrentPage}) => {
     const handleSearchChange = (e) => {
        setSearchValue(e.target.value);
        setCurrentPage(1); // reset page on new search
    };
    return (
        <>
            <div style={{ width: "190px" }}>
                <div className="input-group search-area">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search here..."
                         value={searchValue}
                         onChange={handleSearchChange}
                    />
                    <span className="input-group-text">
                        <Link to={"#"}><i className="flaticon-381-search-2"></i></Link>
                    </span>
                </div>
            </div>
        </>
    )
}

export default SearchFilter